import type { Locale } from '@/lib/serviceCatalog';
import { getAiAnswerEntriesForLang } from '@/lib/aiAnswersCatalog';
import { getHomeHowToMeta, getHomeProcessSteps } from '@/lib/processCatalog';
import {
  buildFaqSchema,
  buildHowToSchema,
  type JsonLd,
} from '@/lib/schema';

const HOME_FAQ_LIMIT = 8;

export function buildHomeAgentReadinessNodes(lang: Locale): JsonLd[] {
  const inLanguage = lang === 'tr' ? 'tr-TR' : 'en-US';
  const faqEntries = getAiAnswerEntriesForLang(lang).slice(0, HOME_FAQ_LIMIT);
  const howToMeta = getHomeHowToMeta(lang);

  return [
    buildFaqSchema(
      faqEntries.map((entry) => ({
        question: entry.questionText,
        answer: entry.directAnswerText,
      })),
      { canonicalPath: '/', inLanguage },
    ),
    buildHowToSchema({
      name: howToMeta.name,
      description: howToMeta.description,
      canonicalPath: '/',
      inLanguage,
      steps: getHomeProcessSteps(lang),
    }),
  ];
}
